import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { PackagesModel } from 'src/models/package/packages';
import { API_url } from 'src/services/api.setup';

const API_Controller = '/Packages';

export const PackagesService = {
  getAllData: async () => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getAllPackages`
      );
      return response.data as PackagesModel[];
    } catch (error) {
      throw error;
    }
  },

  getData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/get?id=${dataId}`
      );
      return response.data as PackagesModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd) => {
    const reModel = {
      Name: dataToAdd.name,
      Description: dataToAdd.description,
      ValidityDays: dataToAdd.validityDays,
      IsActive: dataToAdd.isActive,
      PackageServices: dataToAdd.packageServices.map((packageServices) => ({
        ServiceId: packageServices.service.id,
        Count: packageServices.count,
        Interval: packageServices.interval,
        IsActive: packageServices.isActive
      }))
    };
    
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/create`,
        reModel
      );
      enqueueSnackbar(`Package ${dataToAdd.Name} Added Successfully`, {
        variant: 'success'
      });
      return response.data as PackagesModel[];
    } catch (error) {
      enqueueSnackbar(`Package ${dataToAdd.Name} Add unsuccessfull`, {
        variant: 'success'
      });
      throw error;
    }
  },

  editData: async (dataToAdd) => {
    const reModel = {
      Id: dataToAdd.id,
      Name: dataToAdd.name,
      Description: dataToAdd.description,
      ValidityDays: dataToAdd.validityDays,
      IsActive: dataToAdd.isActive
    };
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        reModel
      );
      enqueueSnackbar(`Package ${dataToAdd.Name} Added Successfully`, {
        variant: 'success'
      });
      return respons.data as PackagesModel[];
    } catch (error) {
      throw error;
    }
  },

  deleteAllData: async (deleteId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/deletePackageFromPackageServices?packageId=${deleteId}`
      );
      enqueueSnackbar(`Package ${data.name} Deleted Successfully`, {
        variant: 'success'
      });
      return response.data as PackagesModel[];
    } catch (error) {
      throw error;
    }
  },
  deleteData: async (packageId, serviceId, data) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/removeServiceFromPackage?packageId=${packageId}&serviceId=${serviceId}`
      );
      enqueueSnackbar(`Service Removed Successfully`, {
        variant: 'success'
      });
      return response.data as PackagesModel[];
    } catch (error) {
      enqueueSnackbar(`Service Removal unsuccessfully`, {
        variant: 'error'
      });
      throw error;
    }
  },

  addServicesInPackage: async (packageId: number, packageServices: any[]) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/addServicesInPackage?packageId=${packageId}`,
        packageServices
      );
      enqueueSnackbar(`Services added successfully`, { variant: 'success' });
      return response.data;
    } catch (error) {
      enqueueSnackbar(`Error adding services: ${error.message}`, { variant: 'error' });
      throw error;
    }
  },

  updateServiceCountAndInterval: async (packageId: number, serviceId: number, count: number, interval: number) => {
    try {
      const response = await axios.put(`${API_url}${API_Controller}/updateServiceCountAndInterval?packageId=${packageId}`, {
        serviceId,
        count,
        interval
      });

      return response
    } catch (error) {
      console.error('error while updating services in packages', error.message)
    }
  }
};
